import React from "react";
import Table from "react-bootstrap/Table";
import styles from "./Table.module.scss";

const DataTable = ({ children }) => {
	return (
		<>
			<Table className={styles.table} responsive>
				{children}
			</Table>
		</>
	);
};

export default DataTable;
